// removed by extract-text-webpack-plugin
module.exports = {"seriesTitleContainer":"seriesTitleContainer__seriesTitleContainer___EPKeh"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/lib/containers/seriesTitleContainer.css
// module id = 1073
// module chunks = 0